export function getCandidatePublishStatus(adminFeatures, featureToggleList, candidateContext) {
  return (
    !!adminFeatures && adminFeatures.AssistedCandidatePublish.IsEnabled && featureToggleList.AssistedSourcing.IsEnabled && candidateContext === 'job'
  );
}

export const candidatePublishRecommendedStatuses = ['AssistedSourcing', 'LinkedinExtension', -15, 6];
